import React from 'react';
import { Select } from 'antd';
import { normalized } from './../../utils/string';
import usePlanServices from './../../hooks/usePlanServices';
import { servicePlanId } from '../../utils/servicePlan';

const { Option } = Select;

// Do not overwrite onChange to keep id as value returned.
const ServicePlanSelect = ({ placeholder = "Buscar plan:", ...restProps }) => {
    const { data, isLoading } = usePlanServices();

    const filterOptionHandler = (input, option) => (normalized(option?.children) ?? '').includes(normalized(input));

    const filterSortHandler = (a, b) => parseInt(a.value.split(",")[0], 10) - parseInt(b.value.split(",")[0], 10);

    return <Select
        {...{ ...restProps, placeholder }}
        loading={isLoading}
        showSearch
        filterOption={filterOptionHandler}
        filterSort={filterSortHandler}>
        {data && data.map((sp) => <Option key={servicePlanId(sp)} value={servicePlanId(sp)}>{sp.name}</Option>)}
    </Select>
}

export default ServicePlanSelect;